import client from "./client";
import { ensureHostKey } from "./hostApi";

// A host's named sets. Every call needs the device's host key (see api/client.js).

/** The caller's sets, most recently used first, each with its songs in order. */
export const list = () => client.get("/Sets/List").then((r) => r.data);

export const get = (setId) => client.get(`/Sets/Get/${setId}`).then((r) => r.data);

/**
 * Creates a set from a list of song ids, or from a session's queue (order and keys included).
 * A device without a host key is registered first.
 */
export const create = async ({ name, songIds = [], fromSession = null }) => {
  await ensureHostKey();
  return client.post("/Sets/Create", { Name: name, SongIds: songIds, FromSession: fromSession }).then((r) => r.data);
};

export const rename = (setId, name) => client.put(`/Sets/Rename/${setId}`, { Name: name }).then((r) => r.data);

export const remove = (setId) => client.delete(`/Sets/Delete/${setId}`, { retry: true });

/** Appends a song to a set and returns it (with Sort and Transpose). Idempotent. */
export const addSong = (setId, songId) =>
  client.put(`/Sets/AddSong/${setId}/${songId}`, null, { retry: true }).then((r) => r.data);

export const removeSong = (setId, songId) => client.delete(`/Sets/RemoveSong/${setId}/${songId}`, { retry: true });

/** Puts the listed songs first, in that order; resolves with the new order of all song ids. */
export const reorder = (setId, songIds) => client.put(`/Sets/Reorder/${setId}`, { SongIds: songIds }).then((r) => r.data);

/** The key a song is sung in when this set is hosted, in semitones from the written key. Idempotent. */
export const setTranspose = (setId, songId, semitones) =>
  client.put(`/Sets/SetTranspose/${setId}/${songId}/${semitones}`, null, { retry: true });

/** Starts a session with the set's songs queued; resolves with the created session (code, token). */
export const host = (setId) => client.post(`/Sets/Host/${setId}`).then((r) => r.data);
